export const oauthPath = "/oauth/:provider";
